import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { createRegisteredContext } from 'react-singleton-context';
import { useResourceData } from '@lumahealthhq/ui-model';
import { useOrderContext } from './OrderContext';
import { usePaginationContext } from './PaginationContext';
import { useSearchContext } from './SearchContext';
import { jsx as _jsx } from "react/jsx-runtime";
const DataResourceContext = createRegisteredContext('ContainerTableDataResourceContext', undefined);
export const useDataResourceContext = () => {
  const context = React.useContext(DataResourceContext);
  if (!context) {
    throw new Error('useDataResourceContext should be used within a DataResourceProvider');
  }
  return context;
};
/**
 * @ignore - internal component.
 */
export function DataResourceProvider({
  resource,
  params = {},
  withSearch,
  children,
  queryOptions,
  customIsLoading
}) {
  var _withSearch$withStar;
  const {
    page,
    rowsPerPage: limit
  } = usePaginationContext();
  const {
    order,
    orderBy
  } = useOrderContext();
  const {
    searchValue
  } = useSearchContext();
  const basicParams = React.useMemo(() => _extends({
    _sort: `${orderBy}:${order}`
  }, params), [params, orderBy, order]);
  const withStar = (_withSearch$withStar = withSearch == null ? void 0 : withSearch.withStar) != null ? _withSearch$withStar : true;
  const search = withSearch != null && withSearch.transformQuery ? withSearch.transformQuery(searchValue) : `${searchValue}${withStar ? '*' : ''}`;
  const tableParams = React.useMemo(() => withSearch ? _extends({}, basicParams, searchValue && {
    [withSearch.query]: search
  }) : basicParams, [withSearch, basicParams, searchValue, search]);
  const {
    data: {
      data,
      totalSize
    },
    isLoading
  } = useResourceData(resource, _extends({
    page,
    limit
  }, tableParams), queryOptions);
  const values = React.useMemo(() => ({
    data,
    isLoading: !!(isLoading || customIsLoading),
    totalSize,
    page
  }), [data, isLoading, customIsLoading, totalSize, page]);
  return /*#__PURE__*/_jsx(DataResourceContext.Provider, {
    value: values,
    children: children
  });
}